/**
 * OGP Fetch Suppression
 *
 * Stores an in-memory flag to temporarily suppress OGP fetch operations.
 */

function createSuppressedFlag(): boolean {
    return false;
}

let suppressed = createSuppressedFlag();

function setOgpFetchSuppressed(value: boolean): void {
    suppressed = value === true;
}

function isOgpFetchSuppressed(): boolean {
    return suppressed;
}

export { isOgpFetchSuppressed, setOgpFetchSuppressed };
